"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchConfigs = exports.logExposure = exports.createExposureLogger = void 0;
const configs_web_1 = require("@snapchat/configs-web");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const grafana_1 = require("./grafana");
const hosts_1 = require("./hosts");
const user_agent_1 = require("./user-agent");
function createExposureLogger() {
    const memo = new Set();
    return async function logExposure(config, webClientId, pageTypeName, payload) {
        if (!(0, hosts_1.isAllowedHost)() || memo.has(config.configId)) {
            return Promise.resolve();
        }
        try {
            memo.add(config.configId);
            await (0, configs_web_1.batchUpdateAbExposure)({
                abExposureData: [
                    {
                        id: {
                            type: configs_web_1.IdType.WEB_CLIENT,
                            value: webClientId,
                        },
                        studyTreatmentInfo: [
                            {
                                studyName: config.studyName,
                                treatmentId: config.experimentId,
                            },
                        ],
                        loggingType: configs_web_1.LoggingType.SERVER_TRIGGER,
                        properties: {
                            geoData: {
                                countryCode: payload.countryCode.toLowerCase(),
                            },
                        },
                    },
                ],
            });
            (0, grafana_1.incrementCounter)(config.configId, pageTypeName, "ExposureLogged.Success" /* GrafanaSuffix.ExposureLoggedSuccess */);
        }
        catch (e) {
            memo.delete(config.configId);
            console.log("Error: batchUpdateAbExposure is failed");
            (0, grafana_1.incrementCounter)(config.configId, pageTypeName, "ExposureLogged.Failure" /* GrafanaSuffix.ExposureLoggedFailure */);
        }
        finally {
            // Flush immediately to ensure this gets pushed to Graphene
            await graphene_1.default.flush();
        }
    };
}
exports.createExposureLogger = createExposureLogger;
exports.logExposure = createExposureLogger();
async function fetchConfigs({ webClientId, namespaces, }) {
    const configTargetingResponse = await (0, configs_web_1.targetingQuery)({
        namespaces,
        ruid: {
            stringValue: webClientId,
            type: configs_web_1.RuidType.WEB_CLIENT,
        },
    }, {
        [user_agent_1.USER_AGENT_HEADER_KEY]: (0, user_agent_1.getCWebUserAgent)(),
    });
    return configTargetingResponse.configResults;
}
exports.fetchConfigs = fetchConfigs;
//# sourceMappingURL=ab.js.map